import {Component, Inject, ViewChild} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef, MdSnackBar, MdSnackBarRef, SimpleSnackBar} from '@angular/material';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ExceptionPhotosComponent} from '../exception-photos/exception-photos.component';
import {FlightFieldGroupService} from '../../../form-renderer/services/flight-field-group/flight-field-group.service';

@Component({
  selector: 'app-exception-modal',
  templateUrl: './exception-dialog.component.html',
  styleUrls: ['./exception-dialog.component.scss']
})
/**
 * Dialog form used to add a new item to a collection of data
 */
export class ExceptionDialogComponent {

  @ViewChild(ExceptionPhotosComponent)
  private exceptionPhotosComponent: ExceptionPhotosComponent;

  addExceptionForm: FormGroup;
  exceptionUploading: boolean;
  private errorSnackBar:  MdSnackBarRef<SimpleSnackBar> = null;

  constructor(public dialogRef: MdDialogRef<ExceptionDialogComponent>,
              @Inject(MD_DIALOG_DATA) public data: DialogData,
              private flightFieldGroupService: FlightFieldGroupService,
              private snackBar: MdSnackBar,
              private formBuilder: FormBuilder) {

    this.addExceptionForm = this.formBuilder.group({
      exception_text: new FormControl(this.data.exceptionText)
    });
  }


  /**
   * Closes the dialog and returns the form value
   */
  async onSubmit() {
      const exceptionText = this.addExceptionForm.value.exception_text;
      this.exceptionUploading = true;
      if (this.errorSnackBar !== null) {
        this.errorSnackBar.dismiss();
      }

      try {
        await this.exceptionPhotosComponent.saveChanges();
        await this.flightFieldGroupService.sendAction({
          type: 'SET_EXCEPTION_TEXT',
          data: {
            exceptionText: exceptionText,
            id: this.data.exceptionId
          }
        }, true);
        this.dialogRef.close(exceptionText);

      } catch (e) {
        this.errorSnackBar = this.snackBar.open('Unable to update exception.', undefined, {
          extraClasses: ['error-snackbar'],
          duration: 7000
        });
        this.exceptionUploading = false;
     }
  }

}

interface DialogData {
  exceptionId: number;
  exceptionText: string;
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/exception-dialog/exception-dialog.component.ts